import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=c5e60238&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=c5e60238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e60238",
  null
  
)

export default component.exports